// extracted by mini-css-extract-plugin
export default {"container":"onboarding_container__jz07f","panel":"onboarding_panel__vcXBi"};